import { createSelector } from "@reduxjs/toolkit";
import selectCategoriesRaw from "./selectCategoriesRaw";

export default createSelector(selectCategoriesRaw, ({ categories }) => categories);
